module.exports = __webpack_public_path__ + "static/profile_picture_destroyed_mouth-2a0db5e24a4cb56352fa879232788fd9.png";